
window.addEventListener('DOMContentLoaded', () => {
    const scrollElements = document.querySelectorAll('[data-scroll-to-top]');
    const schrollEvent = (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    for (let i=0; i<scrollElements.length; i++) {
        scrollElements[i].addEventListener('click', schrollEvent);
    }
});